import { faker } from '@faker-js/faker'

import { HospitalCountry, PartnerLegacyHospital } from '../../contracts/hospital'
import { asBuilder } from '../asBuilder'

export const getPartnerLegacyHospitalFixture = asBuilder((): PartnerLegacyHospital => {
  return {
    status: faker.lorem.word(),
    account: faker.number.int(),
    memo: faker.lorem.paragraph(),
    id: faker.number.int(),
    loginId: faker.lorem.word(),
    lastAccountAddedTime: faker.number.int(),
    hospitalInfo: {
      name: faker.company.name(),
      namePronounce: faker.lorem.word(),
      mainTel1: faker.phone.number('###'),
      mainTel2: faker.phone.number('####'),
      mainTel3: faker.phone.number('####'),
      basicRN: faker.phone.number('###########'),
      basicVN: faker.phone.number('###########'),
      staffName: faker.person.firstName(),
      staffTel1: faker.person.firstName(),
      staffTel2: faker.person.firstName(),
      staffTel3: faker.person.firstName(),
      consStaffNumberList: [faker.phone.number('###########')],
      inboundPhoneNumberList: [faker.phone.number('###########')],
      contentManager: faker.phone.number('###########'),
      smsNumber: faker.phone.number('###########'),
      emailList: [faker.internet.email()],
      emailForTaxBill: faker.internet.email(),
      hospitalContactNumber: faker.phone.number('###########'),
      address: faker.location.streetAddress(),
      addressDetail: faker.location.streetAddress(),
      addressEn: faker.location.streetAddress(),
      addressDetailEn: faker.location.streetAddress(),
      zipCode: faker.location.zipCode(),
      lat: faker.location.latitude(),
      lng: faker.location.longitude(),
      district: faker.location.city(),
      country: faker.helpers.arrayElement([HospitalCountry.KR, HospitalCountry.JP]),
      sido: faker.lorem.word(),
      sigungu: faker.lorem.word(),
      sigunguCode: faker.location.countryCode(),
      subwayCode: faker.location.countryCode(),
      subwayCodeList: [faker.location.countryCode()],
      officeHoursJson: faker.lorem.paragraph(),
      officeHoursEtc: faker.lorem.word(),
      introduction: faker.lorem.paragraph(),
      profileImage: faker.image.url(),
      profileComment: faker.lorem.paragraph(),
      mainImage: faker.image.url(),
      introImage: faker.image.url(),
      photos: [
        {
          id: faker.number.int(),
          createTime: faker.date.anytime().getTime(),
          updateTime: faker.date.anytime().getTime(),
          url: faker.image.url(),
          description: faker.lorem.paragraph(),
          seq: faker.number.int(),
        },
      ],
      authEstimateWrite: faker.datatype.boolean(),
      authTenderView: faker.datatype.boolean(),
      authChatConsultation: faker.datatype.boolean(),
      authLiveConsultation: faker.datatype.boolean(),
      authForeignConsultation: faker.datatype.boolean(),
      cardLevel: faker.number.int(),
      cardLevelFixed: faker.datatype.boolean(),
      badgeCodeList: [faker.lorem.word()],
      awardList: [
        {
          year: faker.lorem.word(),
          month: faker.date.month(),
          title: faker.lorem.word(),
          hid: faker.number.int(),
        },
      ],
      notSupportingCountryList: [faker.lorem.word()],
      supportingLangList: [faker.lorem.word()],
      transls: {
        ja: {
          name: faker.lorem.word(),
          introduction: faker.lorem.word(),
        },
      },
      reviewCount: faker.number.int(),
      reviews: [faker.lorem.paragraph()],
      pageCount: faker.number.int(),
      pages: [faker.lorem.paragraph()],
      viewCount: faker.number.int(),
      agreedToTermsTime: faker.number.int(),
      canChatConsultation: faker.datatype.boolean(),
      canPhoneConsultation: faker.datatype.boolean(),
      canNormalConsultation: faker.datatype.boolean(),
      hospitalJapanInfos: {
        accessRoute: faker.lorem.word(),
        hospitalJapanCreditCardInfo: {
          creditCards: [faker.lorem.word()],
          etc: faker.lorem.word(),
        },
        hospitalJapanMedicalLoan: {
          medicalLoan: faker.lorem.word(),
          etc: faker.lorem.word(),
        },
      },
    },
    priority: faker.number.int(),
    group: {
      id: faker.number.int(),
      name: faker.lorem.word(),
    },
    useYn: faker.lorem.word(),
    forProductSale: faker.datatype.boolean(),
    rating: faker.number.int(),
    ratingCount: faker.number.int(),
    mytproRegId: null,
    crmServiceName: faker.lorem.word(),
    businessLicenseNumber: faker.lorem.word(),
    documents: {
      signedApplicationDocuments: [faker.lorem.word()],
      hospitalBusinessLicenseFiles: [faker.lorem.word()],
      medicalFacilitiesPermissionFiles: [faker.lorem.word()],
      businessLicenseFilesForTaxBill: [faker.lorem.word()],
      agencyBusinessLicenseFiles: [faker.lorem.word()],
    },
    adsCount: faker.number.int(),
    opTagList: [faker.lorem.word()],
    operationTagList: [faker.lorem.word()],
    treatmentCategoryTagIdList: [faker.number.int()],
    treatmentCategoryTagList: [
      {
        id: faker.number.int(),
        name: faker.lorem.word(),
        label: faker.lorem.word(),
        tagMeta: {
          name: faker.lorem.word(),
          nameKr: faker.lorem.word(),
        },
      },
    ],
    liveConsultationCount: faker.number.int(),
    inChargeName: faker.lorem.word(),
    treatmentMenuId: faker.number.int(),
    treatmentMenu: faker.lorem.word(),
    enableTreatmentMenu: faker.datatype.boolean(),
    treatmentMenuItemKeywordList: [faker.lorem.word()],
    recentConsultationMemberCount: faker.number.int(),
    recentVisitedMemberCount: faker.number.int(),
    recentOperatedMemberCount: faker.number.int(),
    createTime: faker.number.int(),
    updateTime: faker.number.int(),
    notificationCount: faker.number.int(),
    firebaseToken: faker.lorem.word(),
    firebaseInputToken: faker.lorem.word(),
    agreements: [
      {
        id: faker.number.int(),
        createTime: faker.date.anytime().getTime(),
        updateTime: faker.date.anytime().getTime(),
        hospitalId: faker.number.int(),
        version: faker.lorem.word(),
        agreedAt: faker.date.anytime().getTime(),
        clauses: faker.lorem.word(),
      },
    ],
    lastLoginPwChangedTime: faker.date.anytime().getTime(),
    channelTalkToken: faker.lorem.word(),
    memberId: faker.number.int(),
  }
})
